import { ACTIONS } from '../../_config'
import { ActionExtended } from '../../_config/interfaces/interfaces';
import { Dialog, Option } from '../../_config/types'
 
export interface MasterReducer {
    states: Option[] | null
    allCounty: Option[] | null
    allCity: Option[] | null
    facilityManagers: Option[] | null
    serviceTechs: Option[] | null
    teams: Option[] | null
    electricityProviders: Option[] | null
    gasProviders: Option[] | null
    waterProviders: Option[] | null
    telephoneProviders: Option[] | null
    assetsCategories:Option[] | null
    assetsDepartments:Option[] | null
    assetsGroups:Option[] | null
    assetsSubGroups:Option[] | null
    assetsTypes:Option[] | null
    assetsClassifications:Option[] | null
    assetsStatues:Option[] | null
}
 
const initialState: MasterReducer = {
    states: null,
    allCounty: null,
    allCity: null,
    facilityManagers: null,
    serviceTechs: null,
    teams: null,
    electricityProviders: null,
    gasProviders: null,
    waterProviders: null,
    telephoneProviders: null,
    assetsCategories:null,
    assetsDepartments:null,
    assetsGroups:null,
    assetsSubGroups:null,
    assetsTypes:null,
    assetsClassifications:null,
    assetsStatues:null

}
 
const masterReducer = (state = initialState, action: ActionExtended) => {
    switch (action.type) {
        case ACTIONS.MASTER.STATES:
            return { ...state, states: action.payload }
        case ACTIONS.MASTER.COUNTY:
            return { ...state, allCounty: action.payload }
        case ACTIONS.MASTER.CITY:
            return { ...state, allCity: action.payload }
        case ACTIONS.MASTER.MANAGERS:
            return { ...state, facilityManagers: action.payload }
        case ACTIONS.MASTER.SERVICE_TECHS:
            return { ...state, serviceTechs: action.payload }
        case ACTIONS.MASTER.TEAMS:
            return { ...state, teams: action.payload }
        case ACTIONS.MASTER.ELECTRICITY_PROVIDERS:
            return { ...state, electricityProviders: action.payload }
        case ACTIONS.MASTER.GAS_PROVIDERS:
            return { ...state, gasProviders: action.payload }
        case ACTIONS.MASTER.WATER_PROVIDERS:
            return { ...state, waterProviders: action.payload }
        case ACTIONS.MASTER.TELEPHONE_PROVIDERS:
            return { ...state, telephoneProviders: action.payload }
        case ACTIONS.MASTER.ASSETS_CATEGORIES:
            return { ...state, assetsCategories: action.payload }
        case ACTIONS.MASTER.ASSETS_DEPARTMENTS:
            return { ...state, assetsDepartments: action.payload }
        case ACTIONS.MASTER.ASSETS_GROUPS:
            return { ...state, assetsGroups: action.payload }
        case ACTIONS.MASTER.ASSETS_SUB_GROUPS:
            return { ...state, assetsSubGroups: action.payload }
        case ACTIONS.MASTER.ASSETS_TYPES:
            return { ...state, assetsTypes: action.payload }
        case ACTIONS.MASTER.ASSETS_CLASSIFICATIONS:
            return { ...state, assetsClassifications: action.payload }
        case ACTIONS.MASTER.ASSETS_STATUES:
            return { ...state, assetsStatues: action.payload }
        default:
            return state
    }
}
 
export default masterReducer